import { Button, Dropdown, Modal } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import WebService from "../../Services/WebService";
import csIcon from "../../assets/images/cs-icon.svg";
import cpIcon from "../../assets/images/cp-icon.svg";
import logout from "../../assets/images/logout.svg";
import myProfile from "../../assets/images/my-profile.svg";
import mySessions from "../../assets/images/my-sessions.svg";
import React, { useState } from "react";
import { GoChevronDown } from "react-icons/go";
import { useDispatch, useSelector } from "react-redux";
import avtar from "../../assets/images/avtar-male.jpg";
import { HELP_NAVIGATE, LOGIN_TYPE } from "../../assets/constants/constants";
import { unregisterDevice } from "../../Services/CommonFunction";
import ChangePassword from "./ChangePassword/ChangePassword";
import HelperService from "../../Services/HelperService";
import SubscriptionIcon from "../../assets/images/menu/subscription.svg";
import { profileCompletionFlags } from "../../assets/interface/primeSharkWebsite_interface";
import { FiLogOut, FiShield } from "react-icons/fi";
import DocumentAccessRequestsModal from "../Profile/DocumentAccessRequestsModal";
interface RightDropdownMenuProps {
  login_type?: string;
  account_type?: string;
}
const RightDropdownMenu = ({
  login_type,
  account_type,
}: RightDropdownMenuProps) => {
  const [showModal1, setShowModal1] = useState(false);
  const [showDocAccessModal, setShowDocAccessModal] = useState(false);
  const { profileDetail, FCMDeviceToken } = useSelector(
    (state: any) => state.items,
  );

  const storeProfileCompletion: profileCompletionFlags = useSelector(
    (state: any) => state?.items?.profileCompletionFlags,
  );
  const [loggingOut, setLoggingOut] = useState(false);
  let {
    has_investment_subscription,
    has_investor_subscription,
    has_investor_subs,
    has_investor_free_subscription,
    has_want_to_sell_subscription,
    has_want_to_sell_profile_completed,
    has_want_to_grow_subscription,
    has_want_to_grow_profile_completed,
    has_want_to_sell_free_subscription,
    has_want_to_grow_free_subscription,
    has_investment_free_subscription,
  } = storeProfileCompletion;

  let dispatch = useDispatch();
  const [show, setShow] = useState(false);

  let navigate = useNavigate();
  let profileName = profileDetail?.name;
  const handleProfileNavigation = (login: string, account: string) => {
    localStorage.setItem("Tab_Selected", "");
    if (login === LOGIN_TYPE.INVESTOR.toLocaleLowerCase()) {
      navigate(`/${login}/my-profile`);
    } else if (login && account) {
      navigate(
        `/${login.toLocaleLowerCase()}/${account?.toLocaleLowerCase()}/my-profile`,
      );
    }
  };
  const handleMySubscriptionNavigation = () => {
    localStorage.setItem("Tab_Selected", "");
    if (login_type === LOGIN_TYPE.INVESTOR.toLocaleLowerCase()) {
      navigate(`/${login_type}/my-subscription`);
    } else if (login_type && account_type) {
      const key = account_type?.toUpperCase() as keyof typeof HELP_NAVIGATE;
      const value = HELP_NAVIGATE[key];
      navigate(
        `/${login_type.toLocaleLowerCase()}/${value?.toLocaleLowerCase()}/my-subscription`,
      );
    }
  };
  let displayRole =
    profileDetail?.role?.role_name ||
    profileDetail?.role?.name ||
    profileDetail?.role?.role ||
    (typeof profileDetail?.role === "string" ? profileDetail?.role : "") ||
    (login_type
      ? LOGIN_TYPE[login_type as keyof typeof LOGIN_TYPE] ?? login_type
      : "") ||
    profileDetail?.user_type ||
    localStorage.getItem("role") ||
    "";

  return (
    <>
      <Dropdown className="profile-dd float-end">
        <Dropdown.Toggle>
          <div className="d-flex gap-2">
            <div className="d-none d-sm-block text-end">
              <p
                className="font-14 mb-0 text-dark font-medium"
                style={{
                  wordBreak: "break-word",
                  overflowWrap: "anywhere",
                }}
              >
                {profileName}
              </p>
              {displayRole && (
                <div
                  className="font-12 mb-0 text-capitalize"
                  style={{ color: "#66C15EDE", marginTop: "2px" }}
                >
                  {HelperService.ProperCase(displayRole)}
                </div>
              )}
            </div>

            <div className="me-2">
              <img
                src={profileDetail?.profile_image ?? avtar}
                width={34}
                height={34}
                className=" rounded-circle object-fit-cover"
                alt=""
              />
            </div>
          </div>
          <GoChevronDown size={16} className="icon" />
        </Dropdown.Toggle>

        <Dropdown.Menu align="end">
          {(has_investment_free_subscription ||
            has_investment_subscription) && (
              <Dropdown.Item
                as={Link}
                to={"javascript:void(0)"}
                onClick={() =>
                  handleProfileNavigation("entrepreneur", "investment")
                }
              >
                <img src={myProfile} alt="MY Profile" /> My Profile (Capital
                Bridge)
              </Dropdown.Item>
            )}
          {(has_want_to_sell_subscription ||
            has_want_to_sell_free_subscription) && (
              <Dropdown.Item
                as={Link}
                to={"javascript:void(0)"}
                onClick={() =>
                  handleProfileNavigation("entrepreneur", "want-to-sell")
                }
              >
                <img src={myProfile} alt="MY Profile" /> My Profile (Business
                Exchange)
              </Dropdown.Item>
            )}
          {(has_want_to_grow_subscription ||
            has_want_to_grow_free_subscription) && (
              <Dropdown.Item
                as={Link}
                to={"javascript:void(0)"}
                onClick={() =>
                  handleProfileNavigation("entrepreneur", "want-to-grow")
                }
              >
                <img src={myProfile} alt="MY Profile" /> My Profile (Global
                Connect)
              </Dropdown.Item>
            )}
          {(has_investor_subscription ||
            has_investor_subs ||
            has_investor_free_subscription) && (
              <Dropdown.Item
                as={Link}
                to={"javascript:void(0)"}
                onClick={() => handleProfileNavigation("investor", "")}
              >
                <img src={myProfile} alt="MY Profile" /> My Profile
              </Dropdown.Item>
            )}

          {login_type !== "investor" && (
            <Dropdown.Item
              as={Link}
              to={"javascript:void(0)"}
              onClick={handleMySubscriptionNavigation}
            >
              <img src={SubscriptionIcon} alt="MY Profile" /> My Subscription
            </Dropdown.Item>
          )}
          {/* {process.env.REACT_APP_ENVIRONMENT === "DEVELOPMENT" && ( */}
          <Dropdown.Item
            as={Link}
            to="/my-sessions"
            onClick={() => localStorage.setItem("Tab_Selected", "")}
          >
            <img src={mySessions} alt="My Sessions" /> My Sessions
          </Dropdown.Item>

          <Dropdown.Item
            as={Link}
            to={"javascript:void(0)"}
            onClick={() => setShowDocAccessModal(true)}
          >
            <FiShield size={22} className="" color="#66C15E" /> Document Access Requests
          </Dropdown.Item>
          {/* )} */}
          {/* <Dropdown.Item as={Link} to="/privacy-policy">
            <img src={prIcon} alt="Privacy Policy" /> Privacy Policy
          </Dropdown.Item>
          <Dropdown.Item as={Link} to="/about-us">
            <img src={aboutIcon} alt="About Us" /> About Us
          </Dropdown.Item>*/}
          <Dropdown.Item
            as={Link}
            to="/contact-support"
            onClick={() => localStorage.setItem("Tab_Selected", "")}
          >
            <img src={csIcon} alt="Contact Support" /> Contact Support{" "}
          </Dropdown.Item>
          <Dropdown.Item
            as={Link}
            to="javascript:void(0)"
            onClick={() => {
              setShowModal1(true);
            }}
          >
            <img src={cpIcon} alt="Change Password" /> Change Password
          </Dropdown.Item>
          <Dropdown.Item
            as={Link}
            to="javascript:void(0)"
            onClick={() => {
              setShow(true);
            }}
          >
            <img src={logout} alt="Logout" /> Logout
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>

      <Modal
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="border-0 p-2 pb-0"
        show={showModal1}
        onHide={() => setShowModal1(false)}
      >
        <Modal.Header closeButton className="border-bottom-1 pb-0 ">
          <h4 className="font-20 m-0">Change Password</h4>
        </Modal.Header>

        <Modal.Body className="p-2 pt-0 mt-4">
          <ChangePassword handleClose={() => setShowModal1(false)} />
        </Modal.Body>
      </Modal>

      <Modal
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={show}
        onHide={() => setShow(false)}
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <div className="w-100 text-center">
            <div className="logout-icon-wrapper mx-auto mb-3">
              <FiLogOut size={28} className="text-danger" />
            </div>

            <h4 className="fw-bold mb-1">Logout?</h4>
          </div>
        </Modal.Header>

        <Modal.Body className="pt-3">
          <div className="text-center mb-4">
            <p className="mb-0 text-secondary">
              Are you sure you want to logout?
            </p>
          </div>

          <div className="d-flex justify-content-center gap-2">
            <button
              type="button"
              className="btn btn-outline-secondary w-50"
              onClick={() => setShow(false)}
              disabled={loggingOut}
            >
              No
            </button>

            <Button
              disabled={loggingOut}
              className="btn btn-primary w-50"
              onClick={async () => {
                setLoggingOut(true);

                try {
                  if (FCMDeviceToken) {
                    await unregisterDevice(FCMDeviceToken, dispatch);
                  } else {
                    dispatch({ type: "DELETE_IDS" });
                    WebService.logout();
                  }
                } finally {
                  setLoggingOut(false);
                }
              }}
            >
              {loggingOut ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  />
                  Logging out...
                </>
              ) : (
                "Yes"
              )}
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      {showDocAccessModal && (
        <DocumentAccessRequestsModal
          show={showDocAccessModal}
          onHide={() => setShowDocAccessModal(false)}
        />
      )}
    </>
  );
};
export default React.memo(RightDropdownMenu);
